import React from 'react';
import AssetPlanDataGrid from '../AssetPlanDataGrid';

const AssetPlans: React.FC = () => {
  return <AssetPlanDataGrid />;
};

export default React.memo(AssetPlans);
